// PoliticaCookiesToppings.jsx
import React, { useEffect, useState } from "react";
import { Container, Typography, Divider, Box, Button } from "@mui/material";
import logo from "../../Recursos/logo.svg"; // tu logo de Toppings

export default function PoliticaCookiesToppings() {
    useEffect(() => {
        document.title = "Política de Cookies - Toppings Colón";
        const meta = document.querySelector('meta[name="description"]');
        const description = "Política de cookies de Toppings Colón: tipos de cookies usadas, finalidad y cómo gestionarlas (Colón, Colombia).";
        if (meta) {
            meta.setAttribute("content", description);
        } else {
            const m = document.createElement("meta");
            m.name = "description";
            m.content = description;
            document.head.appendChild(m);
        }

        const jsonLd = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Política de Cookies - Toppings Colón",
            "url": "https://toppings-colon.web.app/politica-de-cookies"
        };
        const scriptId = "jsonld-politica-cookies";
        let script = document.getElementById(scriptId);
        if (script) script.remove();
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = scriptId;
        script.text = JSON.stringify(jsonLd);
        document.head.appendChild(script);

        return () => {
            const s = document.getElementById(scriptId);
            if (s) s.remove();
        };
    }, []);

    const [consent, setConsent] = useState(() => {
        try {
            return localStorage.getItem("toppings_cookies") === "accepted";
        } catch {
            return false;
        }
    });

    const handleAccept = () => {
        try {
            localStorage.setItem("toppings_cookies", "accepted");
        } catch {}
        setConsent(true);
    };

    const handleReject = () => {
        try {
            localStorage.setItem("toppings_cookies", "rejected");
        } catch {}
        setConsent(false);
    };

    return (
        <Container maxWidth="md" sx={{ py: 6, pt:16 }}>
            {/* Logo */}
            <Box sx={{ textAlign: "center", mb: 4 }}>
                <Box
                    component="img"
                    src={logo}
                    alt="Logo Toppings"
                    sx={{ width: 150, height: "auto" }}
                />
            </Box>

            <Typography variant="h4" component="h1" gutterBottom>
                Política de Cookies
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                Toppings Colón — https://toppings-colon.web.app
            </Typography>
            <Divider sx={{ my: 2 }} />

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">1. ¿Qué son las cookies?</Typography>
                <Typography paragraph>
                    Las cookies son pequeños ficheros almacenados en tu navegador al visitar nuestro sitio. Nos permiten recordar preferencias, mejorar la experiencia y, si se configura, recopilar información estadística de uso.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">2. ¿Qué cookies utilizamos?</Typography>
                <Typography paragraph>
                    Este sitio puede usar las siguientes categorías:
                </Typography>
                <ol>
                    <li><strong>Cookies estrictamente necesarias:</strong> imprescindibles para navegación básica y formularios de contacto.</li>
                    <li><strong>Cookies de rendimiento/analítica (opcionales):</strong> recopilan estadísticas anónimas sobre el uso del sitio (por ejemplo Google Analytics). Se usan solo con tu consentimiento.</li>
                    <li><strong>Cookies funcionales (opcionales):</strong> guardan preferencias para mejorar la experiencia (idioma, visualización de menú, etc.).</li>
                </ol>
                <Typography paragraph>
                    Nota: Actualmente no se gestionan pagos online que requieran cookies específicas.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">3. Duración de las cookies</Typography>
                <Typography paragraph>
                    Pueden ser de sesión (se borran al cerrar el navegador) o persistentes (permanecen un tiempo). La duración depende de cada cookie y del servicio que la origine.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">4. Cómo gestionar y eliminar cookies</Typography>
                <Typography paragraph>
                    Puedes aceptar o rechazar cookies mediante las opciones que ofrecemos. También puedes configurar tu navegador para bloquear o eliminar cookies. Ten en cuenta que bloquear cookies puede afectar funcionalidades del sitio.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">5. Consentimiento</Typography>
                <Typography paragraph>
                    Al continuar navegando sin cambiar preferencias, se entiende que aceptas el uso de cookies conforme a esta política.
                </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle2" gutterBottom>Preferencias de cookies (simulación en cliente)</Typography>
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <Button variant={consent ? "contained" : "outlined"} onClick={handleAccept}>
                    Aceptar cookies
                </Button>
                <Button variant={!consent ? "contained" : "outlined"} onClick={handleReject}>
                    Rechazar cookies
                </Button>
            </Box>

            <Typography variant="body2" color="text.secondary" paragraph>
                Estado actual: {consent ? "Has aceptado cookies (simulado)" : "No has aceptado cookies (simulado)"}.
            </Typography>

            <Box sx={{ mt: 4, p: 2, bgcolor: "background.paper", borderRadius: 1 }}>
                <Typography variant="subtitle2">Aviso:</Typography>
                <Typography variant="body2">
                    Esta política describe las cookies generales usadas en Toppings Colón. Para servicios de terceros (analítica, redes sociales, vídeos embebidos) consulta sus políticas específicas. Este texto es informativo y no sustituye asesoría legal.
                </Typography>
            </Box>
        </Container>
    );
}
